import ReactDOM from "react-dom";
import App from "./App";
import "./global-styles/colors.scss";
import "./global-styles/fonts.scss";
import "./global-styles/common.scss";
import "./recurly.scss";
import "./index.scss";
import DIContext, { DIContainer } from "./core/di";
import dependencies, { Envs } from "./wired-dependencies";
import CONFIG from "./core/consts/config";

// Initialize the app with these dependencies
export const diInitialValue: DIContainer = dependencies(CONFIG.APP_ENV as Envs);

const AppConfigured = () => {
  return (
    <DIContext.Provider value={diInitialValue}>
      <App />
    </DIContext.Provider>
  );
};

ReactDOM.render(<AppConfigured />, document.getElementById("root"));
